import {JsonProperty} from 'json-typescript-mapper';
import { User } from './user.model';
import { Contact } from './';
import {Marketdate} from './marketdate.model';

const enum ContactType {
    'Commune',
    'Merchant',
    'Person',
    'Employee'

}

export class ContactTemp {
    @JsonProperty('id')
    public id?: number;

    @JsonProperty('type')
    public type?: ContactType;

    @JsonProperty('salutation')
    public salutation?: string;

    @JsonProperty('title')
    public title?: string;

    @JsonProperty('firstname')
    public firstname?: string;

    @JsonProperty('lastname')
    public lastname?: string;

    @JsonProperty('displayname')
    public displayname?: string;

    @JsonProperty('company')
    public company?: string;

    @JsonProperty('companyAdditional')
    public companyAdditional?: string;

    @JsonProperty('street')
    public street?: string;

    @JsonProperty('streetAdditional')
    public streetAdditional?: string;

    @JsonProperty('zipcode')
    public zipcode?: string;

    @JsonProperty('city')
    public city?: string;

    @JsonProperty('suburb')
    public suburb?: string;

    @JsonProperty('state')
    public state?: string;

    @JsonProperty('country')
    public country?: string;

    @JsonProperty('phone')
    public phone?: string;

    @JsonProperty('phoneAdditional')
    public phoneAdditional?: string;

    @JsonProperty('fax')
    public fax?: string;

    @JsonProperty('mobile')
    public mobile?: string;

    @JsonProperty('email')
    public email?: string;

    @JsonProperty('emailAdditional')
    public emailAdditional?: string;

    @JsonProperty('web')
    public web?: string;

    @JsonProperty('comment')
    public comment?: string;

    @JsonProperty('companyGguid')
    public companyGguid?: string;

    @JsonProperty('casIsCompany')
    public casIsCompany?: boolean;

    @JsonProperty('casIsContact')
    public casIsContact?: boolean;

    @JsonProperty('latitude')
    public latitude?: string;

    @JsonProperty('longitude')
    public longitude?: string;

    @JsonProperty('boothUnit')
    public boothUnit?: string;

    @JsonProperty('boothType')
    public boothType?: string;

    @JsonProperty('radius')
    public radius?: string;

    @JsonProperty('boothWidth')
    public boothWidth?: number;

    @JsonProperty('boothDepth')
    public boothDepth?: number;

    @JsonProperty('assortment')
    public assortment?: string;

    @JsonProperty('assortmentAdditional')
    public assortmentAdditional?: string;

    @JsonProperty('activeMerchant')
    public activeMerchant?: boolean;

    @JsonProperty('updated')
    public updated?: string;

    @JsonProperty('updatedBy')
    public updatedBy?: User;

    @JsonProperty('created')
    public created?: string;

    @JsonProperty('gguid')
    public gguid?: string;

    @JsonProperty('status')
    public status?: string;

    @JsonProperty('casFunction')
    public casFunction?: string;

    @JsonProperty({clazz: ContactTemp, name: 'contactPerson'})
    public contactPerson?: ContactTemp;

    @JsonProperty({clazz: User, name: 'user'})
    public user?: User;

    @JsonProperty({clazz: Contact, name: 'originalContact'})
    public originalContact?: Contact;

    @JsonProperty({clazz: Contact, name: 'superordinateContact'})
    public superordinateContact?: Contact;

    @JsonProperty({clazz: Marketdate, name: 'marketdate'})
    public marketdate?: Marketdate;

    @JsonProperty('merchantNumber')
    public merchantNumber?: string;

    @JsonProperty('deactivated')
    public deactivated?: boolean;

    @JsonProperty('category')
    public category?: string;

    @JsonProperty('branchString')
    public branchString?: string;

    @JsonProperty('statusArchive')
    public statusArchive?: string;

    @JsonProperty('archivedAt')
    public archivedAt?: string;

    @JsonProperty('archivedBy')
    public archivedBy?: User;

    @JsonProperty('changedAt')
    public changedAt?: string;

    @JsonProperty('changedBy')
    public changedBy?: Contact;

    @JsonProperty('organic')
    public organic?: boolean;

    @JsonProperty('selfProducer')
    public selfProducer?: boolean;

    @JsonProperty('vegan')
    public vegan?: boolean;

    @JsonProperty('responsibleAccordingToTMG')
    public responsibleAccordingToTMG?: boolean;

    @JsonProperty('noWebsiteParticipation')
    public noWebsiteParticipation?: boolean;

    @JsonProperty('advancedMarketwebsite')
    public advancedMarketwebsite?: boolean;

    @JsonProperty('marketwebsiteSelfPresentation')
    public marketwebsiteSelfPresentation?: boolean;

    @JsonProperty('marketwebsiteAdvertisingPresentation')
    public marketwebsiteAdvertisingPresentation?: boolean;

    @JsonProperty('marketwebsiteAdvertisingPresentationFirstActivation')
    marketwebsiteAdvertisingPresentationFirstActivation?: string;

    @JsonProperty('regionalGoods')
    regionalGoods?: boolean;

    @JsonProperty('postalInvoice')
    postalInvoice?: boolean;

  constructor(initNull?: boolean) {
    this.id = void 0;
    this.postalInvoice = void 0;
    this.type = void 0;
    this.salutation = void 0;
    this.title = void 0;
    this.firstname = void 0;
    this.lastname = void 0;
    this.displayname = void 0;
    this.company = void 0;
    this.companyAdditional = void 0;
    this.street = void 0;
    this.streetAdditional = void 0;
    this.zipcode = void 0;
    this.city = void 0;
    this.suburb = void 0;
    this.state = void 0;
    this.country = void 0;
    this.phone = void 0;
    this.phoneAdditional = void 0;
    this.fax = void 0;
    this.mobile = void 0;
    this.email = void 0;
    this.emailAdditional = void 0;
    this.web = void 0;
    this.comment = void 0;
    this.companyGguid = void 0;
    this.casIsCompany = void 0;
    this.casIsContact = void 0;
    this.latitude = void 0;
    this.longitude = void 0;
    this.boothUnit = void 0;
    this.boothType = void 0;
    this.radius = void 0;
    this.boothWidth = void 0;
    this.boothDepth = void 0;
    this.assortment = void 0;
    this.assortmentAdditional = void 0;
    this.activeMerchant = void 0;
    this.updated = void 0;
    this.updatedBy = void 0;
    this.created = void 0;
    this.gguid = void 0;
    this.status = void 0;
    this.casFunction = void 0;
    this.contactPerson = void 0;
    this.user = void 0;
    this.originalContact = void 0;
    this.superordinateContact = void 0;
    this.marketdate = void 0;
    this.merchantNumber = void 0;
    this.deactivated = void 0;
    this.category = void 0;
    this.branchString = void 0;
    this.statusArchive = void 0;
    this.archivedAt = void 0;
    this.archivedBy = void 0;
    this.changedAt = void 0;
    this.changedBy = void 0;
    this.organic = void 0;
    this.selfProducer = void 0;
    this.vegan = void 0;
    this.responsibleAccordingToTMG = void 0;
    this.noWebsiteParticipation = void 0;
    this.advancedMarketwebsite = void 0;
    this.marketwebsiteSelfPresentation = void 0;
    this.marketwebsiteAdvertisingPresentation = void 0;
    this.marketwebsiteAdvertisingPresentationFirstActivation = void 0;
    this.regionalGoods = void 0;

      if (initNull) {
        for (const key of Object.keys(this)) {
          this[key] = null;
        }
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/contact-temp.model.ts